/**
 * The app half of the two Dictate sidebar spotlights' props.
 *
 * Both spotlights mount in the app sidebar on every page, so their app inputs
 * cross as props rather than through the page-scoped Dictate history host. They
 * are bound here, by reference, for every mount: the flag getter, the route read
 * and the sidebar session creator. The session entry point is bound here, so the
 * package takes no session dependency.
 *
 * The flag getter is a static binding as well, so a mount that renders only the
 * logs spotlight (the footer) takes no session hook.
 */
import { useRouter } from 'next/router';

import { IS_DICTATION_LOGS_ENABLED } from '@/app-shell/flags/dictate-flags';
import { useNewSession } from '@/hooks/useNewSession';
import { SessionCreatedEntryPoint } from '@heidi/session/contracts';

/** Props for `DictationLogsSpotlight`. */
export const dictationLogsSpotlightPorts = {
  isDictationLogsEnabled: IS_DICTATION_LOGS_ENABLED,
};

/** Props for both spotlights, for the mounts that render the cross-sell one. */
export const useDictationSidebarSpotlightPorts = () => {
  const router = useRouter();
  const { createNewSession } = useNewSession({
    entryPoint: SessionCreatedEntryPoint.Sidebar,
  });

  return {
    ...dictationLogsSpotlightPorts,
    isOnDictationLogsRoute: router.pathname === '/dictation-logs',
    onStartScribeSession: createNewSession,
  };
};
